import { makeAutoObservable } from 'mobx';

import Collection from '@/collection/entity/Collection';
import { AccessInheritanceAwareCommand } from '@/drive/entities/DriveDestinationCommand';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';

export class SubscribeToCollectionCommand implements AccessInheritanceAwareCommand {
  constructor(private collection: Collection) {
    makeAutoObservable(this);
  }

  get collectionNodeId(): DriveItemId {
    return this.collection.drive.collectionNodeId;
  }

  async getAccessSubjects(): Promise<AccessInheritanceSubject[]> {
    return [];
  }
}
